module.exports = __webpack_public_path__ + "media/src/assets/img/icons/doc-5d02571df6e9a0c50916330daa817747.png";